import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';
import { Roles } from '../constants/roles';

export const roleLabels = {
  [Roles.Admin]: 'Admin',
  [Roles.User]: 'User',
};

const allMenuItems = [
  {
    label: 'Dashboard',
    path: '/app/dashboard',
    icon: DashboardOutlinedIcon,
    roles: [Roles.Admin, Roles.User],
  },
  {
    label: 'Pricing Rules',
    path: '/app/pricing-rules',
    icon: RuleOutlinedIcon,
    roles: [Roles.Admin, Roles.User],
  },
];

export const getMenuItemsForRole = (role) =>
  allMenuItems.filter((item) => !item.roles || item.roles.includes(role));
